import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DownloadMonthlyReportFileRequest = {
  monthlyReportId: number;
  filename: string;
};

export const downloadMonthlyReport = async (request: DownloadMonthlyReportFileRequest) => {
  await executeApiRequest(async () => {
    const response = await axios.get(`/monthlyReports/${request.monthlyReportId}/download`, {
      responseType: "blob"
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", request.filename);
    document.body.appendChild(link);
    link.click();

    return response;
  }, false);
};
